import "../styles/story.css";
// import storyImage from '../../images/tubbees-logo_small.png'

export default function Twentyfive() {
  return (
    <div className="containerStory">
      <div className="storyHeading">
        <h2>2025</h2>
        {/* <img src={storyImage} alt="Tubbees and RaceTrack app" /> */}
      </div>

      <p>
        We relaunched the RT & Tubbees app, bringing customers new rewards,
        points and exclusive offers.
        <br />
        <span>
          By October, our Tubbees and RaceTrack app community had grown to
          more than 10,000 users.
        </span>
      </p>

      <p>
        We also introduced Tubbees Express, taking our first steps towards
        bringing Tubbees slushees to partner retailers.
      </p>
    </div>
  );
}